import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { AuthService } from "../../../auth/services/auth.service";
import { environment } from "../../../../../environments/environment";
import { PERMISSIONS } from "../../../auth/models/permissions.constant";

@Component({
  selector: 'app-menu',
  imports: [CommonModule, MenuItemComponent, RouterModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit {
  menuItems: MenuItem[] = [];
  private authService = inject(AuthService);

  ngOnInit() {
    this.authService.currentUser$.subscribe((user) => {
      this.refreshMenuItems();
    });
  }

  refreshMenuItems() {
    this.menuItems = [
      {
        label: 'Home',
        visible: true,
        items: [
          {
            label: 'Home',
            icon: 'pi pi-fw pi-home',
            routerLink: ['/'],
            visible: true,
          },
        ],
      },
      {
        label: 'Tools',
        visible: true,
        items: [
          {
            label: 'Variable Random Selector',
            icon: 'pi pi-fw pi-question',
            routerLink: ['/tools/random-selector'],
            visible: true,
          },
          {
            id: "tools-web-scraping",
            label: "Web Scraping",
            icon: 'pi pi-fw pi-globe',
            routerLink: ['/tools/web-scraping'],
            visible: this.authService.currentUser?.hasPermission(PERMISSIONS.WEBCRAWLER_VIEW_SCRAPINGRESULT) ?? false,
            items: [
              {
                id: "tools-web-scraping-dashboard",
                label: "Dashboard",
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/tools/web-scraping'],
                visible: this.authService.currentUser?.hasPermission(PERMISSIONS.WEBCRAWLER_VIEW_SCRAPINGRESULT) ?? false,
              },
              {
                id: "tools-web-scraping-gta",
                label: "GTA V Modding",
                icon: 'pi-fw lni lni-game-pad-modern-1',
                routerLink: ['/tools/web-scraping/gta-modding'],
                visible: this.authService.currentUser?.isGtaUpdateTrackerUser() ?? false,
                items: [
                  {
                    id: "tools-web-scraping-gta-overview",
                    label: "Overview",
                    icon: "pi pi-fw pi-th-large",
                    routerLink: ['/tools/web-scraping/gta-modding/'],
                    visible: true,
                  },
                  {
                    id: "tools-web-scraping-gta-timeline",
                    label: "Timeline",
                    icon: "pi pi-fw pi-history",
                    routerLink: ['/tools/web-scraping/gta-modding/timeline'],
                    visible: true,
                  },
                  {
                    id: "tools-web-scraping-gta-data-grid",
                    label: "Data Grid",
                    icon: "pi pi-fw pi-table",
                    routerLink: ['/tools/web-scraping/gta-modding/data-grid'],
                    visible: true,
                  },
                  {
                    id: "tools-web-scraping-gta-stats",
                    label: "Statistics",
                    icon: "pi pi-fw pi-chart-bar",
                    routerLink: ['/tools/web-scraping/gta-modding/stats'],
                    visible: true,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        label: 'Demos',
        icon: "lni lni-board-writing-3",
        visible: this.authService.currentUser?.isStaff ?? false,
        items: [
          {
            id: "demo-oskaru-api",
            label: "oskaru API",
            icon: "pi pi-fw pi-code",
            routerLink: ['/demos/oskaru-api'],
            visible: true,
          },
        ]
      },
      {
        label: 'Shortcuts',
        visible: this.authService.currentUser?.isStaff ?? false,
        items: [
          {
            id: "django-admin",
            label: "Django Admin",
            icon: "pi pi-fw pi-external-link",
            visible: this.authService.currentUser?.isStaff ?? false,
            url: `${environment.oskaruApiUrl}admin/`,
            target: "_blank",
          },
        ]
      }
    ];
  }
}
